import { SvgIcon } from '@mui/material';
import { ReactComponent as UploadIconSVG } from "./upload-icon.svg";

export default function IconUpload(props) {
  return <SvgIcon {...props} component={UploadIconSVG} viewBox="0 0 24 25" />;
}